import { DatePicker, Row } from "antd";
import { DATE_FORMAT } from "../../../../../../lib/constants";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { useCallback, useMemo, useState } from "react";
import { Dayjs } from "dayjs";
import { useUpdatePaymentDate } from "./hooks/useUpdatePaymentDate";
import { IBatchGet } from "../../../../../../types/Batches";

type PaymentDateInputProps = {
  value: Dayjs;
  data: IBatchGet;
  onCloseEdit: () => void;
  updateDataPaymentDate: () => void;
};

export const PaymentDateInput = ({
  data,
  value,
  onCloseEdit,
  updateDataPaymentDate,
}: PaymentDateInputProps) => {
  const [date, setDate] = useState<Dayjs | null>(value);

  const datePickerStatus: undefined | "error" = useMemo(
    () => (date ? undefined : "error"),
    [date]
  );

  const { isLoading, update } = useUpdatePaymentDate(
    onCloseEdit,
    datePickerStatus,
    updateDataPaymentDate,
    data
  );

  const onSave = useCallback(
    () => data.id && update(date, data.id),
    [data, date, update]
  );

  const onChange = useCallback((e: Dayjs | null) => setDate(e), []);

  return (
    <Row className="align-center">
      <DatePicker
        size="small"
        className="ml-1"
        format={DATE_FORMAT}
        value={date}
        disabled={isLoading}
        status={datePickerStatus}
        onChange={onChange}
        placeholder="MM/DD/YY"
      />
      <CheckOutlined
        className="ml-2 ant-btn-link logo-cursor"
        disabled={isLoading}
        onClick={onSave}
      />
      <CloseOutlined
        className="ml-2 ant-btn-link logo-cursor"
        onClick={onCloseEdit}
        disabled={isLoading}
      />
    </Row>
  );
};
